import { bff, createBFFHandlers } from '~/framework/bff';
import { getServerSideMonolithClient } from '~/framework';
import { GetGuideTypeOptionsResponse, getGuideTypeOptions } from '~/monolith-api/guides';

export default createBFFHandlers({
   post: async (req, res) => {
      const monolithClient = getServerSideMonolithClient(req);
      const result = await getGuideTypeOptions({ apiClient: monolithClient });
      res.status(200).json(result);
   },
});

export const getGuideTypeOptionsFromClient = async (): Promise<GetGuideTypeOptionsResponse> => {
   return bff()
      .post('/guides/getGuideTypeOptions')
      .then(response => response.data);
};
